import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { useDebounce } from "use-debounce";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import { getUsersRequest } from "../../store/users/actions";
import { UserTable } from "./UserTable";

const UserList = () => {
  document.title = "Usuários | Ecoguias - Admin Dashboard";
  // const history = useHistory();

  const dispatch = useDispatch();

  const { loading, data } = useSelector((state) => state.Users);

  const [searchInput, setSearchInput] = useState("");
  const [value] = useDebounce(searchInput, 500);

  useEffect(() => {
    dispatch(getUsersRequest(value));
  }, [dispatch, value]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Tabela de usuários" pageTitle="Usuários" />
          <div className="d-flex justify-content-between pb-4 flex-wrap">
            <Input
              type="text"
              style={{ maxWidth: 250 }}
              className="form-control"
              placeholder="Pesquisar..."
              id="search-options"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
          </div>

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Usuários</h5>
                </CardHeader>
                <CardBody>
                  <UserTable
                    style={{ width: "100%" }}
                    users={data?.result}
                    loading={loading}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* <ModalLoading loading={loading} /> */}
    </React.Fragment>
  );
};

export default UserList;
